import React from "react";
import { useNavigate } from "react-router-dom";

const DrivingPro = ()=>{
const navigate = useNavigate();

const scrollToTop = (location) => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(location)
  };


return(
<div className="life-saving">


<h2 className="module-title">Driving Safety Courses</h2>
<div className="driving-pro-pic"></div>


<p className="reading-text">VIRSAT offers 3 Driving Safety VR games. In these series of games trainees experience a typical day in the life of a driver.
Throughout the game, they accompany the driver and must intervene whenever noticing any safety non-compliance. Trainees gain knowledge of road rules and develop the ability and commitment to apply these rules. The game covers essential road rules and addresses crucial vehicle requirements and precautions. Comprehensive preparation for safe and responsible driving is the training's objective.
The three training games demonstrate how fun and safety can go hand in hand. VIRSAT implements driver safety solutions since 2007. This is including dedicated solutions for driving in the challenging conditions of desert roads.
</p>

<p className="blue-text">Driving Safety Games</p>


<ul className="lsr-ul">
    <li >
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Driving+Aware.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/mainImages/driving-aware-all-roads.png" alt="Driving Aware All Roads"className="lsr-aware-image" />
        </a>
    </li>
    <li >
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Black+Top+Driving+Pro.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/mainImages/driving-pro-black-top.png" alt="Driving Pro Black Top"className="lsr-aware-image" />
        </a>
    </li>
    <li >
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Graded+Road+Driving+Pro.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/mainImages/driving-pro-graded-road.png" alt="Driving Pro Graded Road"className="lsr-aware-image" />
        </a>
    </li>
</ul>


<p className="blue-text">Benefits of Driving Safety Training </p>
<p className="orange-bold">Superior Recollection and Understanding</p>

<div className="reading-text">
The design of the Driving Safety VR training goes much deeper than fun. Recollection
and understanding of the rules are boosted in multiple ways:

<ul>
    <li className="bullets">Exceptional learning method</li>
    <li className="bullets">High level of engagement</li>
    <li className="bullets">Learn through making mistakes</li>
    <li className="bullets">High-energy game playing holds the attention</li>
    <li className="bullets">The rules are spoken and written are given in the native language of the worker</li>
    <li className="bullets">Competitive element encouraging continuous learning</li>
    <li className="bullets">Completing the Driving Safety training ensures the the driving rules and are known,
    understood, and recognized.</li>
</ul>
</div>
<p className="orange-bold">Exceptional Learning Method Giving Increased Employee Performance </p>

<p className="reading-text">The Driving Safety VR training is also available as interactive 360 PC training.</p>

<ul className="bar-margin">
    <img src = "/lifeSavingImages/bar-chart.png"  height={500} className="training-image"/>
</ul>

<p className="orange-bold">Comprehensive Curriculum </p>

<p className="reading-text">The Driving Safety training can be followed by VIRSAT's knowledge level training for specific target
groups, such as drivers. </p>

<div className="driving-pro-bottom-pic">
    <h2 className="bottom-title">Access the Life-Saving  <span className="orange-text">Rules </span>™ </h2>
    <button className="body-button" id="button-position" onClick={()=>scrollToTop('/pclicense')}>Access to Play</button>
    <button className="other-games" onClick={()=>scrollToTop('/life-saving')}>Life-Saving Rules Games</button>
</div>

</div>
)
}

export default DrivingPro;
